function Pages() {
  return <div>Pages</div>
}

export default Pages
